import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const mountApp = () => {
    console.log('React App wird initialisiert');

    const rootElement = document.getElementById('root');
    if (rootElement) {
        console.log('Root Element gefunden');
        const root = createRoot(rootElement);
        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>
        );
    } else {
        console.error('Root Element nicht gefunden!');
    }
};

// Beim Embed auf externen Seiten wird das Script nach DOMContentLoaded geladen,
// daher direkt mounten, wenn das DOM bereits bereit ist.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountApp);
} else {
    mountApp();
}